import { Icon, Select, TitleField } from 'components';
import { FilterSpotListModel, SpotClearStatus } from 'models';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { CLEAR_STATUS } from 'uniforms';
import { MOCK_TAG } from 'uniforms/mock-data';
import './FilterSpotModal.scss';

type Props = {
    onSubmit: (clearStatus: SpotClearStatus) => void;
    filter: FilterSpotListModel;
};

const FilterSpotModal = (props: Props): JSX.Element => {
    const { filter, onSubmit } = props;
    const tagRef = useRef<any>(null);
    const [clearStatus, setClearStatus] = useState<SpotClearStatus>({ uncleared: false, cleared: false });
    const [tagList, setTagList] = useState<string[]>([]);

    /**
     * handle choose status filter uncleared or cleared
     */
    const handleChooseStatusFilter = useCallback(
        (status: string) => (): void => {
            if (status === CLEAR_STATUS.UNCLEARED) {
                setClearStatus({ uncleared: !clearStatus.uncleared, cleared: clearStatus.cleared });
            } else if (status === CLEAR_STATUS.CLEARED) {
                setClearStatus({ uncleared: clearStatus.uncleared, cleared: !clearStatus.cleared });
            }
        },
        [clearStatus.cleared, clearStatus.uncleared],
    );

    /**
     * handle search and choose tag
     */
    const handleChooseTag = useCallback(
        e => {
            if (!tagList.find(item => item === e?.label)) {
                setTagList([...tagList, e?.label]);
            }
        },
        [tagList],
    );

    /**
     * handle confirm button
     */
    const handleConfirm = useCallback(() => {
        onSubmit && onSubmit(clearStatus);
    }, [clearStatus, onSubmit]);

    /**
     * handle reset
     */
    const handleReset = useCallback(() => {
        setTagList([]);
        setClearStatus({ uncleared: false, cleared: false });
        tagRef?.current?.handleResetValue();
    }, []);

    useEffect(() => {
        if (filter) {
            setClearStatus({ uncleared: filter.spot_clear_status !== 1, cleared: filter.spot_clear_status !== 0 });
        }
    }, [filter]);

    return useMemo(
        () => (
            <div className="filter-spot-modal-container">
                <div className="default-frame mb-4">
                    <TitleField icon={<Icon.FilterSpot />} title="クリア状態" />
                    <div className="clear-status-container">
                        {Object.keys(CLEAR_STATUS).map(key => {
                            return (
                                <div
                                    key={key}
                                    onClick={handleChooseStatusFilter(CLEAR_STATUS[key])}
                                    className={`clear-status-box ${
                                        (CLEAR_STATUS[key] === CLEAR_STATUS.UNCLEARED && clearStatus.uncleared) ||
                                        (CLEAR_STATUS[key] === CLEAR_STATUS.CLEARED && clearStatus.cleared)
                                            ? 'active'
                                            : ''
                                    }`}>
                                    <div className="clear-status-text">{CLEAR_STATUS[key]}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="default-frame mb-4">
                    <TitleField icon={<Icon.Tag />} title="タグ" />
                    <div className="tag-container">
                        <Select
                            ref={tagRef}
                            className="select-tag"
                            showIndicator={false}
                            showIcon={true}
                            icon={<Icon.MagnifyingGlass />}
                            options={MOCK_TAG.map(item => {
                                return { label: item.tag_name, value: item.tag_id };
                            })}
                            onChange={handleChooseTag}
                        />
                        <div className="tag-list">
                            {tagList &&
                                tagList[0] &&
                                tagList.map(item => {
                                    return (
                                        <div className="tag-box-container" key={item}>
                                            <div className="tag-item">{item}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </div>

                <div className="default-frame mb-4">
                    <TitleField icon={<Icon.Person />} title="登録者" />
                    <div className="tag-registrant-container">
                        <Select className="select-tag-registrant" />
                    </div>
                </div>

                <div className="btn-container">
                    <Button className="red-btn w-50" onClick={handleReset}>
                        選択をリセット
                    </Button>
                    <Button className="green-btn w-50" onClick={handleConfirm}>
                        決定
                    </Button>
                </div>
            </div>
        ),
        [clearStatus, handleChooseStatusFilter, handleChooseTag, handleConfirm, handleReset, tagList],
    );
};

export default FilterSpotModal;
